export default __webpack_public_path__ + "static/media/47.e5655b49.png";